import { render } from "./Rumicenter.vue?vue&type=template&id=25aa9cf9"
import script from "./Rumicenter.vue?vue&type=script&lang=js"
export * from "./Rumicenter.vue?vue&type=script&lang=js"

import "./Rumicenter.vue?vue&type=style&index=0&id=25aa9cf9&lang=css"

import exportComponent from "/Volumes/LACIE/vueSites/yem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__